module.exports = __webpack_public_path__ + "img/fr_badge_appstore.f24f9277.png";